import { lazy } from "react";

const IconList = lazy(() => import("../helpers/icons"));
const B2BRebatesDetails = lazy(() => import("../pages/B2BRebates/B2BRebatesDetails/B2BRebatesDetails"));
const B2BRebatesListPage = lazy(() => import("../pages/B2BRebates/B2BRebatesListPage"));
const B2BRebateTiersListPage = lazy(() => import("../pages/B2BRebateTiers/B2BRebateTiersListPage"));
const Countries = lazy(() => import("../pages/Countries/Countries"));
const PricesGroupsListPage = lazy(() => import("../pages/PricesGroups/PricesGroupsListPage"));
const Towns = lazy(() => import("../pages/Towns/Towns"));
const Streets = lazy(() => import("../pages/Streets/Streets"));
const Brands = lazy(() => import("../pages/Brands/Brands"));
const Stores = lazy(() => import("../pages/Stores/Stores"));
const Municipalities = lazy(() => import("../pages/Municipalities/Municipalities"));
const Manufacturers = lazy(() => import("../pages/Manufacturers/Manufacturers"));
const Logistics = lazy(() => import("../pages/Logistics/Logistics"));
const ProductDetails = lazy(() => import("../pages/Products/ProductDetails/ProductDetails"));
const ProductGroupDetails = lazy(() => import("../pages/ProductSpecs/ProductGroupDetails/ProductGroupDetails"));
const ProductsPriceMarkets = lazy(() => import("../pages/ProductsPriceMarkets/ProductsPriceMarkets"));
const ProductSpecsGroups = lazy(() => import("../pages/ProductSpecs/ProductSpecsGroups"));
const EOffer = lazy(() => import("../pages/EOffer/EOffer"));
const ProductVariantsAttributesDetails = lazy(() => import("../pages/ProductVariantsAttributes/ProductVariantsAttributeDetails/ProductVariantsAttributeDetails"));
const AdminForm = lazy(() => import("../pages/AdminForm/AdminForm"));
const AdminFormDetails = lazy(() => import("../pages/AdminForm/AdminFormDetails/AdminFormDetails"));
const B2CNews = lazy(() => import("../pages/B2CNews/B2CNews"));
const B2CNewsDetails = lazy(() => import("../pages/B2CNews/B2CNewsDetails/B2CNewsDetails"));
const B2CNewsCategoryList = lazy(() => import("../pages/B2CNewsCategoryList/B2CNewsCategoryList"));
const B2CNewsCategoryListDetails = lazy(() => import("../pages/B2CNewsCategoryList/B2CNewsCategoryListDetails/B2CNewsCategoryListDetails"));
const B2Bbanners = lazy(() => import("../pages/B2Bbanners/B2Bbanners"));
const B2CStaticPages = lazy(() => import("../pages/B2CStaticPages/B2CStaticPages"));
const B2CStaticPagesDetails = lazy(() => import("../pages/B2CStaticPages/B2CStaticPagesDetails/B2CStaticPagesDetails"));
const B2CLandingPages = lazy(() => import("../pages/B2CLandingPages/B2CLandingPages"));
const B2CLandingPagesDetails = lazy(() => import("../pages/B2CLandingPages/B2CLandingPagesDetails/B2CLandingPagesDetails"));
const B2CMarketing = lazy(() => import("../pages/B2CMarketing/B2CMarketing"));
const B2CMarketingDetails = lazy(() => import("../pages/B2CMarketing/B2CMarketingDetails/B2CMarketingDetails"));
const B2CCustomers = lazy(() => import("../pages/B2CCustomers/B2CCustomers"));
const B2CCustomersDetails = lazy(() => import("../pages/B2CCustomers/B2CCustomersDetails/B2CCustomersDetails"));
const Promotions = lazy(() => import("../pages/Promotions/Promotions"));
const Newsletter = lazy(() => import("../pages/Newsletter/Newsletter"));
const B2CContactForm = lazy(() => import("../pages/B2CContactForm/B2CContactForm"));
const AdminSettings = lazy(() => import("../pages/AdminSettings/AdminSettings"));
const B2Bsettings = lazy(() => import("../pages/B2Bsettings/B2Bsettings"));
const B2Cbanners = lazy(() => import("../pages/B2Cbanners/B2Cbanners"));
const B2CSettings = lazy(() => import("../pages/B2CSettings/B2CSettings"));
const Import = lazy(() => import("../pages/Import/Import"));
const ImportDetails = lazy(() => import("../pages/Import/ImportDetails/ImportDetails"));
const DetailsParams = lazy(() => import("../pages/Params/DetailsParams/DetailsParams"));
const Params = lazy(() => import("../pages/Params/Params"));
const Products = lazy(() => import("../pages/Products/Products"));
const CategoriesGroupsListPage = lazy(() => import("../pages/Categories/CategoriesGroupsListPage"));
const CategoriesDetails = lazy(() => import("../pages/Categories/CategoriesDetails/CategoriesDetails"));
const Notifications = lazy(() => import("../pages/Notifications/Notifications"));
const CategoriesListPage = lazy(() => import("../pages/Categories/CategoriesList/CategoriseListPage"));
const CategoriesTree = lazy(() => import("../pages/Categories/CategoriesTree/CategoriesTree"));
const Companies = lazy(() => import("../pages/Companies/Companies"));
const CompaniesDetails = lazy(() => import("../pages/Companies/CompaniesDetails/CompaniesDetails"));

const CronJobs = lazy(() => import("../pages/CronJobs/CronJobs"));
const CronJobsLogsByDays = lazy(() => import("../pages/CronJobs/LogsByDays/CronJobsLogsByDays"));
const CronJobsLogsDayByTimes = lazy(() => import("../pages/CronJobs/LogsDayByTimes/CronJobsLogsDayByTimes"));
const CronJobsLogDetails = lazy(() => import("../pages/CronJobs/LogDetails/CronJobsLogDetails"));
const CronJobsLogsHistory = lazy(() => import("../pages/CronJobs/LogsHistory/CronJobsLogsHistory"));

const SaleOfficers = lazy(() => import("../pages/SaleOfficers/SaleOfficers"));
const B2BbannersPositions = lazy(() => import("../pages/B2BbannersPositions/B2BbannersPositions"));
const B2CbannersPositions = lazy(() => import("../pages/B2CbannersPositions/B2CbannersPositions"));
const B2BOrders = lazy(() => import("../pages/B2BOrders/B2BOrders"));
const B2BOrdersDetails = lazy(() => import("../pages/B2BOrders/Details/B2BOrdersDetails"));
const RolesListPage = lazy(() => import("../pages/Roles/RolesListPage"));
const RolesDetailsPage = lazy(() => import("../pages/Roles/RolesDetails/RolesDetailsPage"));
const Users = lazy(() => import("../pages/Users/Users"));
const AdminSettingsDetails = lazy(() => import("../pages/AdminSettings/SettingsDetails/AdminSettingsDetails"));
const B2BSettingsDetails = lazy(() => import("../pages/B2Bsettings/SettingsDetails/B2BSettingsDetails"));
const B2CSettingsDetails = lazy(() => import("../pages/B2CSettings/SettingsDetails/B2CSettingsDetails"));
const B2BContactForm = lazy(() => import("../pages/B2BContactForm/B2BContactForm"));
const PackageHistory = lazy(() => import("../pages/B2COrders/DetailsOrders/PackageHistory/PackageHistory"));
const PackagePrint = lazy(() => import("../pages/B2COrders/DetailsOrders/PackagePrint/PackagePrint"));


const B2COrders = lazy(() => import("../pages/B2COrders/B2COrders"));
const B2COrdersDetails = lazy(() => import("../pages/B2COrders/DetailsOrders/B2COrdersDetails"));
const B2CPackagesOverview = lazy(() => import("../pages/B2COrders/PackagesOverview/list/B2CPackagesOverview"));
const B2CPackageOverviewLabelBookPrint = lazy(() => import("../pages/B2COrders/PackagesOverview/labelBookPrint/B2CPackageOverviewLabelBookPrint"));
const B2CPackageOverviewLabelPrint = lazy(() => import("../pages/B2COrders/PackagesOverview/labelPrint/B2CPackageOverviewLabelPrint"));
const B2CEmployees = lazy(() => import("../pages/B2CEmployees/B2CEmployees"));
const Scripts = lazy(() => import("../pages/Scripts/Scripts"));
const B2CContactFormDetails = lazy(() => import("../pages/B2CContactForm/B2CContacFormDetails/B2CContactFormDetails"));
const Homepage = lazy(() => import("../pages/Homepage/Homepage"));
const Error404 = lazy(() => import("../pages/Error/Error404"));
const B2BContactFormDetails = lazy(() => import("../pages/B2BContactForm/DetailsContactForm/B2BContactFormDetails"));
const B2CWorkingUnit = lazy(() => import("../pages/B2CWorkingUnit/B2CWorkingUnit"));
const B2CCareer = lazy(() => import("../pages/B2CCareer/B2CCareer"));
const Export = lazy(() => import("../pages/Export/Export"));
const ExportDetails = lazy(() => import("../pages/Export/ExportDetails/ExportDetails"));
const B2BStaticPages = lazy(() => import("../pages/B2BStaticPages/B2BStaticPages"));
const B2BStaticPagesDetails = lazy(() => import("../pages/B2BStaticPages/B2BStaticPagesDetails/B2BStaticPagesDetails"));
const B2BLandingPages = lazy(() => import("../pages/B2BLandingPages/B2BLandingPages"));
const B2BLandingPagesDetails = lazy(() => import("../pages/B2BLandingPages/B2BLandingPagesDetails/B2BLandingPagesDetails"));
const PromotionsCatalogCampaignsPageDetails = lazy(() => import("../pages/Promotions/PromotionsCatalogCampaigns/PromotionsCatalogCampaignsPageDetails/PromotionsCatalogCampaignsPageDetails"));
const PromotionsCartSummaryDetails = lazy(() => import("../pages/Promotions/PromotionsCartSummary/PromotionsCartSummaryDetails/PromotionsCartSummaryDetails"));
const PromotionsCartItemsDetails = lazy(() => import("../pages/Promotions/PromotionsCartItems/PromotionsCartItemsDetails/PromotionsCartItemsDetails"));
const PromotionsDeliveryCampaignsDetails = lazy(() => import("../pages/Promotions/PromotionsDeliveryCampaigns/PromotionsDeliveryCampaignsDetails/PromotionsDeliveryCampaignsDetails"));
const PromotionsRecommendedDetails = lazy(() => import("../pages/Promotions/PromotionsRecommended/PromotionsRecommendedDetails/PromotionsRecommendedDetails"));
const PromotionsCrossSellsDetails = lazy(() => import("../pages/Promotions/PromotionsCrossSells/PromotionsCrossSellsDetails/PromotionsCrossSellsDetails"));
const PromotionsUpSellsDetails = lazy(() => import("../pages/Promotions/PromotionsUpSells/PromotionsUpSellsDetails/PromotionsUpSellsDetails"));
const B2BReclamations = lazy(() => import("../pages/B2BReclamations/B2BReclamations"));
const B2BReclamationsDetails = lazy(() => import("../pages/B2BReclamations/B2BReclamationsDetails/B2BReclamationsDetails"));
const EOfferDetails = lazy(() => import("../pages/EOffer/EOfferDetails/EOfferDetails"));
const EponudaFeedAccounts = lazy(() => import("../pages/EponudaFeedAccounts/EponudaFeedAccounts"));
const EponudaFeedAccountsDetails = lazy(() => import("../pages/EponudaFeedAccounts/EponudaFeedAccountsDetails/EponudaFeedAccountsDetails"));
const PromoCodesCartSummaryDetails = lazy(() => import("../pages/Promotions/PromoCodesCartSummary/PromoCodesCartSummaryDetails/PromoCodesCartSummaryDetails"));
const PromoCodesCartSummaryCodes = lazy(() => import("../pages/Promotions/PromoCodesCartSummary/PromoCodesCartSummaryDetails/Codes/Codes"));
const PromoCodesCartItemsDetails = lazy(() => import("../pages/Promotions/PromoCodesCartItems/PromoCodesCartItemsDetails/PromoCodesCartItemsDetails"));
const PromoCodesCartItemsCodes = lazy(() => import("../pages/Promotions/PromoCodesCartItems/PromoCodesCartItemsDetails/Codes/Codes"));
const Reports = lazy(() => import("../pages/Reports/reports"));
const ReportsSales = lazy(() => import("../pages/ReportsSales/ReportsSales"));
const ReportsCustomers = lazy(() => import("../pages/ReportsCustomers/ReportsCustomers"));
const PromotionReports = lazy(() => import("../pages/PromotionsReports/PromotionReports"));
const Reviews = lazy(() => import("../pages/Reviews/Reviews"));
const ReviewsCommentDetails = lazy(() => import("../pages/Reviews/tabs/ReviewsComments/ReviewsCommentDetails"));
const AddCommentReply = lazy(() => import("../pages/Reviews/tabs/ReviewsComments/AddCommentReply"));
const ReviewsQuestionDetails = lazy(() => import("../pages/Reviews/tabs/ReviewsQuestions/ReviewsQuestionDetails"));
const AddQuestionAnswers = lazy(() => import("../pages/Reviews/tabs/ReviewsQuestions/AddQuestionAnswers"));
const StoresDetails = lazy(() => import("../pages/Stores/StoresDetails/StoresDetails"));
const SystemDocumentation = lazy(() => import("../pages/SystemDocumentation/Swagger/Swagger"));
import { makeScreen, MenuGroup } from "./utils";

const ProductContentSection = lazy(() => import("../pages/Products/ProductDetails/ProductContentSection/ProductContentSection"));

/** The list of available screens. */
const { PRODUCT, SALE, B2B, B2C, COMPANY_SETTINGS, SETTINGS, REPORTS } = MenuGroup;
const screens = {
    HOMEPAGE: ["/homepage", "", "", "", Homepage],
    ERROR404: ["*", "", "", "", Error404, []],

    // Reports
    REPORTS_SALES: ["/reports/sales", "Prodaja", IconList.fileOpen, REPORTS, ReportsSales, []],
    REPORTS_CUSTOMERS: ["/reports/customers", "Kupci", IconList.group, REPORTS, ReportsCustomers, []],
    REPORTS_PRODUCTS: ["/reports/products", "Proizvodi", IconList.inventory, REPORTS, Reports, []],
    REPORTS_CAMPAIGNS: ["/reports/promotions", "Promocije", IconList.celebration, REPORTS, PromotionReports, []],

    B2C_ORDERS: [
        "/b2c-orders",
        "Porudžbine",
        IconList.fileOpen,
        SALE,
        B2COrders,
        [
            [":orderId", B2COrdersDetails],
            [":orderId/:packageId/:courierId/:packageNumber", PackageHistory],
            ["print/:orderId/:packageId/:courierId/:packageNumber", PackagePrint],
            ["packages-overview", B2CPackagesOverview],
            ["packages-overview/label-print", B2CPackageOverviewLabelPrint],
            ["packages-overview/label-book-print", B2CPackageOverviewLabelBookPrint]
        ],
    ],
    B2B_ORDERS: ["/b2b-orders", "Porudžbine", IconList.fileOpen, SALE, B2BOrders, [[":orderId", B2BOrdersDetails]]],
    BANNERS_B2C: ["/b2c-banners", "Baneri", IconList.image, SALE, B2Cbanners, [["positions", B2CbannersPositions]]],
    BANNERS_B2B: ["/b2b-banners", "Baneri", IconList.image, SALE, B2Bbanners, [["positions", B2BbannersPositions]]],
    B2C_LANDING_PAGES: ["/b2c-landingpages", "Promo strane", IconList.autoStories, SALE, B2CLandingPages, [[":lid", B2CLandingPagesDetails]]],
    B2B_LANDING_PAGES: ["/b2b-landingpages", "Promo strane", IconList.autoStories, SALE, B2BLandingPages, [[":lid", B2BLandingPagesDetails]]],
    PROMOTIONS: ["/promotions", "Promocije", IconList.celebration, SALE, Promotions, [["promotions-catalog-campaigns/:nid", PromotionsCatalogCampaignsPageDetails]]],
    PROMOTIONS: [
        "/promotions",
        "Promocije",
        IconList.celebration,
        SALE,
        Promotions,
        [
            ["promotions-catalog-campaigns/:nid", PromotionsCatalogCampaignsPageDetails],
            ["promotions-cart-summary-campaigns/:nid", PromotionsCartSummaryDetails],
            ["promotions-cart-items-campaigns/:nid", PromotionsCartItemsDetails],
            ["promotions-delivery-campaigns/:nid", PromotionsDeliveryCampaignsDetails],
            ["promotions-recommended/:rid", PromotionsRecommendedDetails],
            ["promotions-cross-sells/:rid", PromotionsCrossSellsDetails],
            ["promotions-up-sells/:rid", PromotionsUpSellsDetails],
            ["promo-codes-cart-summary-campaigns/:pid", PromoCodesCartSummaryDetails],
            ["promo-codes-cart-summary-campaigns/:pId/new", PromoCodesCartSummaryCodes],
            ["promo-codes-cart-items-campaigns/:pid", PromoCodesCartItemsDetails],
            ["promo-codes-cart-items-campaigns/:pId/new", PromoCodesCartItemsCodes],
        ],
    ],
    CATEG: [
        "/product-categories",
        "Kategorije",
        IconList.category,
        PRODUCT,
        CategoriesGroupsListPage,
        [
            ["tree/:gid", CategoriesTree],
            ["category/:gid", CategoriesListPage],
            ["category/:gid/:cid", CategoriesDetails],
        ],
    ],
    PRODU: [
        "/products",
        "Proizvodi",
        IconList.inventory,
        PRODUCT,
        Products,
        [
            [":prodId/product-content-sections/:pageId/:sectionId", ProductContentSection],
            [":prodId", ProductDetails],
            ["prices-groups", PricesGroupsListPage],
            ["price-markets", ProductsPriceMarkets],
            ["product-items-variants-attributes/group-attribute", ProductVariantsAttributesDetails],
            ["product-specs/groups", ProductSpecsGroups],
            ["product-specs/groups/:groupId", ProductGroupDetails],
        ],
    ],
    //PRODUCT_SPEC: ["/product-specs/groups", "Specifikacija", IconList.inventory, PRODUCT, ProductSpecsGroups, [[":groupId", ProductGroupDetails]]],
    IMPORT: ["/import", "Uvoz podataka", IconList.download, PRODUCT, Import, [[":upId", ImportDetails]]],
    EXPORT: ["/export", "Izvoz podataka", IconList.upload, PRODUCT, Export, [[":exId", ExportDetails]]],
    EPONUDA: [
        "/eponuda",
        "E-ponuda",
        IconList.inventory,
        PRODUCT,
        EOffer,
        [
            [":id", EOfferDetails],
            ["accounts", EponudaFeedAccounts],
            ["accounts/:id", EponudaFeedAccountsDetails],
        ],
    ],
    COMPN: ["/b2b-companies", "Kompanije", IconList.locationCity, B2B, Companies, [[":comId", CompaniesDetails]]],
    REBATE_TIERS: ["/b2b-rebate-tiers", "Rabatne skale", IconList.barChart, B2B, B2BRebateTiersListPage],
    REBATES: ["/b2b-rebates", "Rabati", IconList.percent, B2B, B2BRebatesListPage, [[":rebateId", B2BRebatesDetails]]],
    B2B_SALES_OFFICER: ["/b2b-sales-officers", "Komercijalisti", IconList.manageAccounts, B2B, SaleOfficers],
    B2B_NOTIFICATIONS: ["/b2b-notifications", "Notifikacije", IconList.notifications, B2B, Notifications],
    B2B_CONTACT_FORMS: ["/b2b-contact", "Kontakt forma", IconList.markunreadMailbox, B2B, B2BContactForm, [[":id", B2BContactFormDetails]]],
    B2B_STATIC_PAGES: ["/b2b-staticpages", "Statičke strane", IconList.autoStories, B2B, B2BStaticPages, [[":spid", B2BStaticPagesDetails]]],
    RECLAMATIONS_B2B: ["/b2b-reclamations", "Reklamacije", IconList.receiptLong, B2B, B2BReclamations, [[":rid", B2BReclamationsDetails]]],

    B2C_NEWS: [
        "/b2c-news",
        "Vesti",
        IconList.newspaper,
        B2C,
        B2CNews,
        [
            [":nid", B2CNewsDetails],
            ["category", B2CNewsCategoryList],
            ["category/:cid", B2CNewsCategoryListDetails],
        ],
    ],
    B2C_STATIC_PAGES: ["/b2c-staticpages", "Statičke strane", IconList.autoStories, B2C, B2CStaticPages, [[":spid", B2CStaticPagesDetails]]],
    B2C_CUSTOMERS: ["/b2c-customers", "Kupci", IconList.group, B2C, B2CCustomers, [[":cid", B2CCustomersDetails]]],
    B2C_NEWSLETTER: ["/b2c-newsletter", "Newsletter", IconList.notificationsActive, B2C, Newsletter, [[":nlid", Newsletter]]],
    B2C_CONTACT_FORMS: ["/b2c-contactform", "Kontakt forma", IconList.markunreadMailbox, B2C, B2CContactForm, [[":id", B2CContactFormDetails]]],
    B2C_EMPLOYEES: ["/b2c-employees", "Zaposleni", IconList.badge, B2C, B2CEmployees],
    B2C_WORKING_UNITS: ["/b2c-working-unit", "Radne jedinice", IconList.engineering, B2C, B2CWorkingUnit],
    B2C_CAREER: ["/b2c-career", "Karijera", IconList.notes, B2C, B2CCareer],
    // RECLAMATIONS_B2C: ["/b2c-reclamations", "Reklamacije", IconList.receiptLong, B2C, B2CReclamations, [[":rid", B2CReclamationsDetails]]],

    ROLES: ["/roles", "Uloge", IconList.reduceCapacity, COMPANY_SETTINGS, RolesListPage, [[":roleId", RolesDetailsPage]]],
    USERS: ["/users", "Korisnici", IconList.group, COMPANY_SETTINGS, Users],

    COUNTRIES: ["/countries", "Države", IconList.flag, COMPANY_SETTINGS, Countries],
    MUNICIPALITIES: ["/municipalities", "Opštine", IconList.locationCity, COMPANY_SETTINGS, Municipalities],
    TOWNS: ["/towns", "Mesta", IconList.apartment, COMPANY_SETTINGS, Towns],
    STREETS: ["/streets", "Ulice", IconList.addRoad, COMPANY_SETTINGS, Streets],
    BRANDS: ["/brands", "Brendovi", IconList.copyright, COMPANY_SETTINGS, Brands],
    STORES: ["/stores", "Skladišta", IconList.store, COMPANY_SETTINGS, Stores, [[":storeId", StoresDetails]]],
    MANUFACTURERS: ["/manufacturers", "Proizvođači", IconList.factory, COMPANY_SETTINGS, Manufacturers],
    LOGISTICS: ["/logistics", "Logistika", IconList.warehouse, COMPANY_SETTINGS, Logistics],

    ADMINCFG: ["/admin-settings", "Admin podešavanja", IconList.settings, SETTINGS, AdminSettings, [[":AdminId", AdminSettingsDetails]]],
    SYSTEM_DOCUMENTATION: ["/system-documentation", "Dokumentacija", IconList.settings, SETTINGS, SystemDocumentation],
    B2BCFG: ["/b2b-settings", "B2B podešavanja", IconList.settings, SETTINGS, B2Bsettings, [[":B2BId", B2BSettingsDetails]]],
    B2CCFG: ["/b2c-settings", "B2C podešavanja", IconList.settings, SETTINGS, B2CSettings, [[":B2CId", B2CSettingsDetails]]],
    ADMIN_SCRIPTS: ["/scripts", "Skripte", IconList.description, SETTINGS, Scripts],
    ADMIN_FORM: ["/admin-form", "Admin forme", IconList.list, SETTINGS, AdminForm, [[":formId", AdminFormDetails]]],
    PARAMS: ["/params", "Parametri", IconList.settings, SETTINGS, Params, [[":pid", DetailsParams]]],

    CRON_JOB_COMMANDS: [
        "/cron-jobs",
        "Cron jobs",
        IconList.viewTimeline,
        SETTINGS,
        CronJobs,
        [
            ["history/:cron_job_command_id", CronJobsLogsHistory],
            [":cron_job_command_id", CronJobsLogsByDays],
            [":cron_job_command_id/:date_folder", CronJobsLogsDayByTimes],
            [":cron_job_command_id/:date_folder/:time_folder", CronJobsLogDetails],
        ],
    ],

    REVIEWS: [
        "/reviews",
        "Recenzije",
        IconList.reviews,
        SALE,
        Reviews,
        [
            ["comment-details/:nid", ReviewsCommentDetails],
            ["comment-details/:nid/reply/new", AddCommentReply],
            ["question-details/:nid", ReviewsQuestionDetails],
            ["question-details/:nid/answers/new", AddQuestionAnswers]
        ],
    ],

    MARKETING_B2C: [
        "/b2c-marketing",
        "Marketing",
        IconList.campaign,
        SALE,
        B2CMarketing,
        [
            [":campaignId", B2CMarketingDetails],
        ],
    ],

    
};

/**
 * Builds the screens from the configuration above.
 *
 * @typedef AvailableScreen
 *    @property {string} name
 *    @property {string} path
 *    @property {JSX.Element} icon
 *    @property {string} group
 *    @property {JSX.Element} component
 *    @property {AvailableScreen[]} children
 */
export const availableScreens: AvailableScreen[] = {};
for (const code in screens) {
    availableScreens[code] = makeScreen(screens[code]);
}
